export default [
    //纪念日提醒
    {
      path: '/wage/anniversary',
      name: '纪念日提醒',
      component: () => import ( /* webpackChunkName: "table" */ `@/views/wage/anniversary/anniversary.vue`),
    }
  ]
